(function () {
  'use strict';

  var EROS_PRODUCT_ID = 7076810064069;
  var EROS_VARIANT_IDS = [41079557062853, 41079557095621];
  var FREE_GIFT_VARIANT_ID = 43947866915013;
  var FREE_GIFT_CODE = 'EROS-FREESB';
  var FREE_GIFT_PROPERTY = '_free_gift';

  var originalFetch = window.fetch.bind(window);
  var erosAddInFlight = null;
  var preflightCart = null;
  var preflightCartPromise = null;
  var lastKnownCart = null;
  var promoErosKey = null;
  var promoGiftKey = null;
  var addFeedback = null;
  var cartObserver = null;
  var cleanupBusy = false;
  var cleanupTimer = null;
  var allowGiftDiscountRepair = false;

  function requestJson(url, options) {
    return originalFetch(url, options).then(function (response) {
      return response.json().catch(function () {
        return {
          status: response.status,
          description: 'Shopify returned an unexpected response.'
        };
      }).then(function (data) {
        if (!response.ok || data.status === 422) {
          throw data;
        }

        return data;
      });
    });
  }

  function jsonResponse(data) {
    return new Response(JSON.stringify(data), {
      status: 200,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  function getCart() {
    var cartUrl = window.theme && theme.routes && theme.routes.cart
      ? theme.routes.cart
      : '/cart.js';

    if (!/\.js(\?|$)/.test(cartUrl)) {
      cartUrl = cartUrl.replace(/\/?$/, '') + '.js';
    }

    return requestJson(cartUrl + (cartUrl.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    });
  }

  function cachePreflightCart(cart) {
    var eros = getErosItem(cart);
    var gift = getFreeGift(cart);

    preflightCart = cart;
    lastKnownCart = cart;
    promoErosKey = eros ? String(eros.key) : null;
    promoGiftKey = gift ? String(gift.key) : null;

    if (gift && isGiftDiscountApplied(cart, gift)) {
      allowGiftDiscountRepair = true;
    }

    decorateGiftLine(cart);
    return cart;
  }

  function invalidatePreflightCart() {
    preflightCart = null;
    preflightCartPromise = null;
  }

  function preloadCart(force) {
    if (!force && preflightCart) {
      return Promise.resolve(preflightCart);
    }

    if (!force && preflightCartPromise) {
      return preflightCartPromise;
    }

    preflightCartPromise = getCart().then(
      function (cart) {
        preflightCartPromise = null;
        return cachePreflightCart(cart);
      },
      function (error) {
        preflightCartPromise = null;
        throw error;
      }
    );

    return preflightCartPromise;
  }

  function getDiscountCode(discount) {
    if (!discount) {
      return '';
    }

    return String(discount.code || discount.title || '')
      .trim()
      .toUpperCase();
  }

  function hasOtherDiscount(cart) {
    if (!Array.isArray(cart.discount_codes)) {
      return false;
    }

    return cart.discount_codes.some(function (discount) {
      var code = getDiscountCode(discount);

      if (!code || code === FREE_GIFT_CODE) {
        return false;
      }

      return true;
    });
  }

  function hasEros(cart) {
    return cart.items.some(function (item) {
      return Number(item.product_id) === EROS_PRODUCT_ID;
    });
  }

  function getErosItem(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return undefined;
    }

    return cart.items.find(function (item) {
      return Number(item.product_id) === EROS_PRODUCT_ID ||
        EROS_VARIANT_IDS.indexOf(Number(item.variant_id || item.id)) !== -1;
    });
  }

  function getFreeGift(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return undefined;
    }

    return cart.items.find(function (item) {
      return Number(item.variant_id) === FREE_GIFT_VARIANT_ID &&
        item.properties &&
        String(item.properties[FREE_GIFT_PROPERTY] || '').toUpperCase() === FREE_GIFT_CODE;
    });
  }

  function isGiftDiscountApplied(cart, gift) {
    if (!cart || !gift) {
      return false;
    }

    var codeIsApplied = Array.isArray(cart.discount_codes) &&
      cart.discount_codes.some(function (discount) {
        return getDiscountCode(discount) === FREE_GIFT_CODE &&
          discount.applicable !== false;
      });
    var allocations = gift.line_level_discount_allocations ||
      gift.discount_allocations ||
      [];
    var giftAllocationIsApplied = allocations.some(function (allocation) {
      return getDiscountCode(allocation.discount_application || allocation) === FREE_GIFT_CODE;
    });
    var finalLinePrice = gift.final_line_price;

    if (finalLinePrice == null && gift.final_price != null) {
      finalLinePrice = Number(gift.final_price) * (Number(gift.quantity) || 1);
    }

    return Number(finalLinePrice) === 0 &&
      (codeIsApplied || giftAllocationIsApplied);
  }

  function cartHasWorkingGift(cart) {
    var gift = cart ? getFreeGift(cart) : null;
    return Boolean(gift && isGiftDiscountApplied(cart, gift));
  }

  function ensureUiStyles() {
    if (document.getElementById('eros-free-gift-ui-styles')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'eros-free-gift-ui-styles';
    style.textContent =
      '.eros-add-pending .btn--loading span{' +
        'display:inline-flex!important;' +
        'align-items:center;' +
        'justify-content:center;' +
        'gap:9px;' +
        'color:inherit!important;' +
      '}' +
      '.eros-add-pending .btn--loading span:before{' +
        'content:"";' +
        'display:inline-block;' +
        'width:15px;' +
        'height:15px;' +
        'flex:0 0 15px;' +
        'box-sizing:border-box;' +
        'border:2px solid currentColor;' +
        'border-right-color:transparent;' +
        'border-radius:50%;' +
        'animation:erosGiftButtonSpin .7s linear infinite;' +
      '}' +
      '.eros-add-pending .btn--loading span:after{' +
        'display:none!important;' +
        'content:none!important;' +
        'background-image:none!important;' +
        'animation:none!important;' +
      '}' +
      '@keyframes erosGiftButtonSpin{' +
        'to{transform:rotate(360deg);}' +
      '}' +
      '#CartDrawer .eros-free-gift-line{' +
        'position:relative;' +
        'margin:10px 0;' +
        'padding:14px;' +
        'border:1px solid #b8d8c0;' +
        'border-radius:12px;' +
        'background:linear-gradient(135deg,#f4fbf6 0%,#eef8f1 100%);' +
        'box-shadow:0 4px 14px rgba(28,105,55,.08);' +
      '}' +
      '#CartDrawer .eros-free-gift-badge{' +
        'display:inline-flex;' +
        'align-items:center;' +
        'margin:0 0 7px;' +
        'padding:4px 9px 1px 9px;' +
        'border-radius:999px;' +
        'background:#18743a;' +
        'color:#fff;' +
        'font-size:14px !important;' +
        'font-weight:500;' +
        'letter-spacing:.08em;' +
        'line-height:1.2;' +
      '}' +
      '#CartDrawer .eros-free-gift-note{' +
        'display:block;' +
        'margin-top:6px;' +
        'color:black;' +
        'font-size:14px;' +
        'font-weight:500;' +
        'line-height:1.35;' +
      '}' +
      '#CartDrawer .eros-free-gift-line .cart__item--qty{' +
        'display:none!important;' +
      '}' +
      '#CartDrawer .eros-free-gift-line .cart__discount{' +
        'color:#18743a!important;' +
        'font-weight:700;' +
      '}';

    document.head.appendChild(style);
  }

  function isErosForm(form) {
    if (!form || typeof FormData === 'undefined') {
      return false;
    }

    var formData = new FormData(form);
    var productId = Number(
      formData.get('data-product-id') ||
      formData.get('product-id') ||
      0
    );
    var variantId = Number(formData.get('id'));

    return productId === EROS_PRODUCT_ID ||
      EROS_VARIANT_IDS.indexOf(variantId) !== -1;
  }

  function startAddFeedback(form) {
    stopAddFeedback();

    var spans = Array.prototype.slice.call(
      form.querySelectorAll('[data-add-to-cart-text]')
    );

    if (!spans.length) {
      return;
    }

    addFeedback = {
      form: form,
      spans: spans.map(function (span) {
        return {
          element: span,
          text: span.textContent
        };
      }),
      dots: 0,
      timer: null
    };

    form.classList.add('eros-add-pending');

    function updateText() {
      if (!addFeedback) {
        return;
      }

      addFeedback.dots = (addFeedback.dots % 3) + 1;
      var text = 'Adding to cart' + '.'.repeat(addFeedback.dots);

      addFeedback.spans.forEach(function (item) {
        item.element.textContent = text;
      });
    }

    updateText();
    addFeedback.timer = setInterval(updateText, 450);
  }

  function stopAddFeedback() {
    if (!addFeedback) {
      return;
    }

    clearInterval(addFeedback.timer);
    addFeedback.form.classList.remove('eros-add-pending');
    addFeedback.spans.forEach(function (item) {
      item.element.textContent = item.text;
    });
    addFeedback = null;
  }

  function decorateGiftLine(cart) {
    var drawer = document.getElementById('CartDrawer');

    if (!drawer) {
      return;
    }

    var taggedGift = cart ? getFreeGift(cart) : null;
    var gift = taggedGift && isGiftDiscountApplied(cart, taggedGift)
      ? taggedGift
      : null;
    var eros = cart ? getErosItem(cart) : null;
    var erosKey = eros ? String(eros.key) : promoErosKey;
    var giftKey = gift ? String(gift.key) : promoGiftKey;
    var rows = drawer.querySelectorAll('.cart__item[data-key]');
    var erosRow = null;
    var giftRow = null;

    Array.prototype.forEach.call(rows, function (row) {
      var rowKey = row.getAttribute('data-key');
      var isGift = giftKey && rowKey === giftKey;
      var existingBadge = row.querySelector('.eros-free-gift-badge');
      var existingNote = row.querySelector('.eros-free-gift-note');

      if (erosKey && rowKey === erosKey) {
        erosRow = row;
      }

      if (isGift) {
        giftRow = row;
      }

      row.classList.toggle('eros-free-gift-line', Boolean(isGift));

      if (!isGift) {
        if (existingBadge) {
          existingBadge.remove();
        }

        if (existingNote) {
          existingNote.remove();
        }

        return;
      }

      var nameContainer = row.querySelector('.cart__item--name');
      var quantityInput = row.querySelector('.js-qty__num');

      if (quantityInput) {
        quantityInput.readOnly = true;
        quantityInput.setAttribute('aria-label', 'Free gift quantity: 1');
      }

      if (nameContainer && !existingBadge) {
        var badge = document.createElement('span');
        badge.className = 'eros-free-gift-badge';
        badge.textContent = '🎁 FREE GIFT UNLOCKED!';
        nameContainer.insertBefore(badge, nameContainer.firstChild);
        existingBadge = badge;
      }

      var discountLabel = row.querySelector('.cart__discount');
      if (existingBadge && discountLabel) {
        existingBadge.style.fontSize = window.getComputedStyle(discountLabel).fontSize;
      }

      if (nameContainer && !existingNote) {
        var note = document.createElement('span');
        note.className = 'eros-free-gift-note';
        note.textContent = 'Get this gift FREE when you check out today.';
        nameContainer.appendChild(note);
      }
    });

    if (
      erosRow &&
      giftRow &&
      erosRow.parentNode === giftRow.parentNode &&
      erosRow.nextElementSibling !== giftRow
    ) {
      erosRow.parentNode.insertBefore(giftRow, erosRow.nextElementSibling);
    }
  }

  function observeCartDrawer() {
    var products = document.querySelector('#CartDrawer [data-products]');

    if (!products || cartObserver) {
      return;
    }

    cartObserver = new MutationObserver(function () {
      if (lastKnownCart) {
        decorateGiftLine(lastKnownCart);
      }
    });

    cartObserver.observe(products, {
      childList: true,
      subtree: true
    });
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') {
      return input;
    }

    if (input && input.url) {
      return input.url;
    }

    return String(input || '');
  }

  function getUrlPath(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return url.split('?')[0];
    }
  }

  function isCartAddRequest(input, options) {
    var cartAddUrl = window.theme && theme.routes && theme.routes.cartAdd
      ? theme.routes.cartAdd
      : '/cart/add.js';
    var method = String((options && options.method) || 'GET').toUpperCase();

    return method === 'POST' &&
      getUrlPath(getRequestUrl(input)) === getUrlPath(cartAddUrl);
  }

  function getRequestParams(options) {
    if (!options || !options.body) {
      return null;
    }

    if (typeof options.body === 'string') {
      return new URLSearchParams(options.body);
    }

    if (options.body instanceof URLSearchParams) {
      return new URLSearchParams(options.body.toString());
    }

    return null;
  }

  function getErosSubmission(options) {
    var params = getRequestParams(options);

    if (!params) {
      return null;
    }

    var variantId = Number(params.get('id'));
    var productId = Number(
      params.get('data-product-id') ||
      params.get('product-id') ||
      0
    );

    if (
      productId !== EROS_PRODUCT_ID &&
      EROS_VARIANT_IDS.indexOf(variantId) === -1
    ) {
      return null;
    }

    var erosItem = {
      id: variantId,
      quantity: Math.max(1, Number(params.get('quantity')) || 1)
    };
    var properties = {};

    params.forEach(function (value, name) {
      var propertyMatch = name.match(/^properties\[(.+)\]$/);

      if (propertyMatch && value !== '') {
        properties[propertyMatch[1]] = value;
      }
    });

    if (Object.keys(properties).length) {
      erosItem.properties = properties;
    }

    var sellingPlan = params.get('selling_plan');
    if (sellingPlan) {
      erosItem.selling_plan = Number(sellingPlan) || sellingPlan;
    }

    return erosItem;
  }

  function getCombinedAddOptions(originalOptions, erosItem) {
    var options = Object.assign({}, originalOptions || {});

    options.method = 'POST';
    options.credentials = options.credentials || 'same-origin';
    options.headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    };
    options.body = JSON.stringify({
      items: [
        erosItem,
        {
          id: FREE_GIFT_VARIANT_ID,
          quantity: 1,
          properties: {
            '_free_gift': FREE_GIFT_CODE
          }
        }
      ]
    });

    return options;
  }

  /* Reads a cart JSON body; if the body is not a cart, fetches the cart instead. */
  function readCartFromResponse(response) {
    return response.json().then(function (data) {
      return data && Array.isArray(data.items) ? data : getCart();
    }, function () {
      return getCart();
    });
  }

  /* Preferred: apply the code through the Ajax Cart API (no page load). */
  function applyGiftCodeViaCartApi() {
    return originalFetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        discount: FREE_GIFT_CODE
      })
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Cart API could not apply ' + FREE_GIFT_CODE + '.');
      }

      return readCartFromResponse(response);
    });
  }

  /* Fallback: the classic /discount/CODE link, redirected to cart JSON instead of the full cart page. */
  function applyGiftCodeViaUrl() {
    return originalFetch(
      '/discount/' + encodeURIComponent(FREE_GIFT_CODE) +
        '?redirect=' + encodeURIComponent('/cart.js'),
      {
        method: 'GET',
        credentials: 'same-origin',
        redirect: 'follow',
        headers: {
          'Accept': 'application/json'
        }
      }
    ).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to apply ' + FREE_GIFT_CODE + '.');
      }

      return readCartFromResponse(response);
    });
  }

  /*
   * Applies the gift code AFTER the gift is already in the cart, then confirms
   * the gift line is actually free. Resolves { applied: boolean, cart: cart }.
   */
  function ensureGiftDiscount() {
    return applyGiftCodeViaCartApi()
      .catch(function () {
        return null;
      })
      .then(function (cart) {
        if (cartHasWorkingGift(cart)) {
          return cart;
        }

        return applyGiftCodeViaUrl().catch(function () {
          return getCart();
        });
      })
      .then(function (cart) {
        return {
          applied: cartHasWorkingGift(cart),
          cart: cart
        };
      });
  }

  function changeGiftQuantity(lineKey, quantity) {
    var cartChangeUrl = window.theme && theme.routes && theme.routes.cartChange
      ? theme.routes.cartChange
      : '/cart/change.js';

    return requestJson(cartChangeUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    });
  }

  function removePromoGift() {
    return getCart().then(function (cart) {
      var gift = getFreeGift(cart);

      if (!gift) {
        return cart;
      }

      return changeGiftQuantity(gift.key, 0);
    });
  }

  /*
   * Step 1: add Eros + gift together (this also creates the cart if the visitor has none).
   * Step 2: only then apply the discount code, so both changes land on the same cart
   *         and cannot overwrite each other.
   * Step 3: hand the theme a normal single line item response, like a regular add.
   */
  function addErosAndGift(input, options, erosItem) {
    return originalFetch(input, getCombinedAddOptions(options, erosItem))
      .then(function (response) {
        if (!response.ok) {
          console.warn(
            'EROS free gift could not be added (it may be sold out); adding the scale on its own.'
          );

          return originalFetch(input, options).then(function (plainResponse) {
            invalidatePreflightCart();
            return plainResponse;
          });
        }

        return response.json()
          .catch(function () {
            return getCart();
          })
          .then(function (data) {
            var items = data && Array.isArray(data.items) ? data.items : [];
            var eros = getErosItem({ items: items });
            var gift = getFreeGift({ items: items });

            if (eros && eros.key) {
              promoErosKey = String(eros.key);
            }

            if (gift && gift.key) {
              promoGiftKey = String(gift.key);
            }

            return ensureGiftDiscount()
              .then(function (result) {
                if (result.applied) {
                  cachePreflightCart(result.cart);
                  return;
                }

                console.warn(
                  'EROS free gift discount did not apply; removing the promotional bottle.'
                );

                return removePromoGift();
              })
              .catch(function (error) {
                console.error('EROS free gift discount step failed.', error);

                return removePromoGift().catch(function (cleanupError) {
                  console.error(
                    'EROS free gift bottle could not be removed after the discount failed.',
                    cleanupError
                  );
                });
              })
              .then(function () {
                invalidatePreflightCart();
                return jsonResponse(eros || data);
              });
          });
      });
  }

  function cloneResponse(response) {
    return response && typeof response.clone === 'function'
      ? response.clone()
      : response;
  }

  function installCartAddInterceptor() {
    window.fetch = function (input, options) {
      if (!isCartAddRequest(input, options)) {
        return originalFetch(input, options);
      }

      var erosItem = getErosSubmission(options);

      if (!erosItem) {
        return originalFetch(input, options);
      }

      if (erosAddInFlight) {
        return erosAddInFlight.then(cloneResponse);
      }

      /* Always check the live cart at click time, not a copy saved at page load. */
      erosAddInFlight = preloadCart(true).then(
        function (cart) {
          if (hasOtherDiscount(cart) || getFreeGift(cart)) {
            return originalFetch(input, options).then(function (response) {
              invalidatePreflightCart();
              return response;
            });
          }

          return addErosAndGift(input, options, erosItem);
        },
        function (error) {
          console.warn(
            'EROS free gift preflight failed; continuing with the normal product add.',
            error
          );

          return originalFetch(input, options);
        }
      );

      erosAddInFlight.then(function () {
        setTimeout(function () {
          erosAddInFlight = null;
        }, 0);
      }, function () {
        setTimeout(function () {
          erosAddInFlight = null;
        }, 0);
      });

      return erosAddInFlight.then(
        cloneResponse,
        function (error) {
          stopAddFeedback();
          throw error;
        }
      );
    };
  }

  function refreshCartMarkup() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function runCleanup() {
    if (erosAddInFlight) {
      scheduleCleanup(400);
      return;
    }

    if (cleanupBusy) {
      return;
    }

    cleanupBusy = true;

    getCart()
      .then(function (cart) {
        cachePreflightCart(cart);

        var gift = getFreeGift(cart);

        if (!gift) {
          return false;
        }

        if (!hasEros(cart) || hasOtherDiscount(cart)) {
          return changeGiftQuantity(gift.key, 0).then(function () {
            invalidatePreflightCart();
            return true;
          });
        }

        if (!isGiftDiscountApplied(cart, gift)) {
          if (!allowGiftDiscountRepair) {
            return changeGiftQuantity(gift.key, 0).then(function () {
              invalidatePreflightCart();
              return true;
            });
          }

          allowGiftDiscountRepair = false;

          return ensureGiftDiscount()
            .then(function (result) {
              var repairedCart = result.cart;
              cachePreflightCart(repairedCart);

              var repairedGift = getFreeGift(repairedCart);

              if (
                repairedGift &&
                hasEros(repairedCart) &&
                !hasOtherDiscount(repairedCart) &&
                result.applied
              ) {
                return true;
              }

              if (!repairedGift) {
                return true;
              }

              return changeGiftQuantity(repairedGift.key, 0).then(function () {
                invalidatePreflightCart();
                return true;
              });
            }, function (error) {
              console.warn('EROS free gift discount could not be restored.', error);

              return changeGiftQuantity(gift.key, 0).then(function () {
                invalidatePreflightCart();
                return true;
              });
            });
        }

        if (gift.quantity !== 1) {
          return changeGiftQuantity(gift.key, 1).then(function () {
            invalidatePreflightCart();
            return true;
          });
        }

        return false;
      })
      .then(function (cartChanged) {
        if (cartChanged) {
          refreshCartMarkup();
        }
      })
      .catch(function (error) {
        console.warn('EROS free gift cleanup skipped.', error);
      })
      .finally(function () {
        cleanupBusy = false;
      });
  }

  function scheduleCleanup(delay) {
    clearTimeout(cleanupTimer);
    cleanupTimer = setTimeout(runCleanup, delay || 400);
  }

  ensureUiStyles();
  installCartAddInterceptor();
  observeCartDrawer();

  window.erosFreeGiftStatus = {
    installed: true,
    version: '3.5.0',
    strategy: 'cart-add-interceptor-sequential'
  };

  preloadCart().catch(function () {
    /* The click handler will safely fall back to the native add. */
  });

  document.addEventListener('submit', function (event) {
    if (isErosForm(event.target)) {
      startAddFeedback(event.target);
    }
  }, true);

  document.addEventListener('ajaxProduct:added', function () {
    setTimeout(stopAddFeedback, 0);
    invalidatePreflightCart();
    scheduleCleanup(500);
  });

  document.addEventListener('product:added', function () {
    setTimeout(stopAddFeedback, 0);
    invalidatePreflightCart();
    scheduleCleanup(500);
  });

  document.addEventListener('ajaxProduct:error', function () {
    setTimeout(stopAddFeedback, 0);
  });

  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) {
      cachePreflightCart(event.detail.cart);
    } else {
      invalidatePreflightCart();
    }

    scheduleCleanup(300);
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      allowGiftDiscountRepair = false;
      invalidatePreflightCart();
      scheduleCleanup(100);
    }
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      invalidatePreflightCart();
      scheduleCleanup(150);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeCartDrawer();
      scheduleCleanup(1200);
    });
  } else {
    scheduleCleanup(1200);
  }
})();